<template>  
  <div class="pr-4 scrollable-container">     
   <!-- RG-DON-026d — onglet déjà ouvert (état restauré) : rien n'est chargé sans le post-traitement image -->
   <div v-if="!tenantEnabled" class="w-full flex justify-center align-center pa-4">
    <span>{{$t('Pilot.Images.DisabledForTenant')}}</span>
   </div>
   <template v-else>
   <div class="ma-2 flex items-center justify-center">
     <v-btn small :color="!showAll?'secondary':'primary'" @click="showAll=false" >{{$t(`Pilot.Images.Single`)}}</v-btn>
     <v-btn small :color="showAll?'secondary':'primary'" @click="showAll=true" >{{$t(`Pilot.Images.Concat`)}}</v-btn>      
   </div>        
   <MissionDetailImagePic v-for="pic in queryablePics" :cycle="pic.yoCycle" :pic="pic.picNumber" :mis-id="mission.misId" :key="pic.picNumber"/>   
   <div v-if="queryablePics.length == 0" class="w-full flex justify-center align-center pa-4">
    <span>{{$t('Pilot.Ad2cp.NoDataAvailable')}}</span>
  </div>     
   </template>
  </div>
 </template>

<script lang="ts">
  import Vue from 'vue'
  //@ts-ignore
  import Component from 'vue-class-component'
  import deepEqual from 'deep-equal'  
  import { Watch} from 'vue-property-decorator'
  import { MissionUi } from '@/models/ui/MissionUi';  
  import { IrisConfigContainer } from '@/models/iris/IrisConfigContainer';
  import { IAd2cpConfig, getDefaultAd2cpConfig } from '@/models/iris/ad2cp/IAd2cpConfig';
  import { VuetifyConfirmObject } from 'vuetify-confirm'
  import apiMission from '@/api/mission'    
  import { buildMissionUIStateId } from '@/models/ui/MissionUiState';
  import MissionDetailImagePic from '@/components/mission/MissionDetailImagePic.vue'
  import { AloMission } from '@/models/alo/AloMission';

  @Component({
    name: 'MissionDetailImage',
    components:{MissionDetailImagePic},
     props:{
      mission: {
        type: AloMission,
        required: true
      }
    },
  })
  export default class MissionDetailImage extends Vue {  
        
    mission!: AloMission
             
   
    refresh = false
    showAll = false        
    lastPics = false

    // RG-DON-026d — post-traitement image de l'enseigne du planeur de la mission
    get tenantEnabled(){
      return !!this.$store.getters.enseigneConfigFor(this.mission.ensId)?.postprocess_image
    }

    get queryablePics(){
      this.refresh;
      return  ((this.pics?this.pics:this.lastPics) || [])
    }
    

    get missionUiid(){
      return buildMissionUIStateId(this.mission.misId!,'detail')
    }

    get missionState(){
        return this.$store.myGetters.missionUiStateByUiid(this.missionUiid)
    }

    get currentYosIndex(){
      return this.missionState.timelineIndex != -1?this.missionState.timelineIndex:(this.mission.yoArray.length-1)
    }
   
    get currentCycle(){
        return this.mission.yoArray[this.currentYosIndex].yosCycle
    }

    get pics() {       
       this.refresh;
       const cacheKey = `irisimgcache_${this.mission.misId!}_${this.showAll?'all':this.currentCycle}`
       const cacheImgKey = 'liste'
      //@ts-ignore
      return window[cacheKey] && window[cacheKey][cacheImgKey]
    }

    
   
    loadImageListe() {      
      if (!this.tenantEnabled) return
      const cacheKey = `irisimgcache_${this.mission.misId!}_${this.currentCycle}`                   
      const cacheAllKey = `irisimgcache_${this.mission.misId!}_all`             
      const cacheImgKey = `liste`  
      
      const cacheQueryKey =  this.showAll?cacheAllKey:cacheKey      
      //@ts-ignore
      if(!window[cacheKey]) window[cacheKey] = {}            
      //@ts-ignore
      if(!window[cacheAllKey]) window[cacheAllKey] = {} 
      //@ts-ignore
      if(window[cacheQueryKey][cacheImgKey] == undefined) {
        //@ts-ignore
        window[cacheQueryKey][cacheImgKey] = 0
        //@ts-ignore
        apiMission.getIrisImageList(this.mission.misId!,this.currentCycle?.toString()).then((response) => {
          //@ts-ignore
          window[cacheKey][cacheImgKey] = response?.data?.filter(p => p.yoCycle != 'all')
          //@ts-ignore
          window[cacheAllKey][cacheImgKey] = response?.data?.filter(p => p.yoCycle == 'all')
          this.refresh = !this.refresh        
          //@ts-ignore
          this.lastPics = window[cacheQueryKey][cacheImgKey]
        }).catch((error:any) => {
          //@ts-ignore
          window[cacheQueryKey][cacheImgKey] = false 
          this.refresh = !this.refresh      
          this.lastPics = false
        })
      }
      else{
        //@ts-ignore
        this.lastPics = window[cacheQueryKey][cacheImgKey]
      }      
    }

    get refreshPicture(){
      return this.$store.myGetters.refreshPicture
    }
    
    
    mounted() {
      this.loadImageListe()
    }    
   

    @Watch('currentCycle')
    onCurrentCycleChanged(newValue: any) {   
      if(!this.showAll) this.loadImageListe()                           
    }
    
    @Watch('mission')
    onMissionChanged(newValue: any) {   
      this.loadImageListe()                           
    }

    @Watch('tenantEnabled')
    onTenantEnabledChanged() {
      this.loadImageListe()
    }

    @Watch('refreshPicture')
    onRefreshPictureChanged(newValue: any) {   
      this.loadImageListe()                           
    }
    
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
  .subheading,.body-2{
    font-weight: bold;  
  }

  .flex-container{
    display:flex;
    flex-direction:column;
    position:relative;
  }

</style>
